import React from 'react';

function Component({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="13.5" y="13" width="6.5" height="6.5" rx="1.3" />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.3" />
      <rect x="4" y="13" width="6.5" height="6.5" rx="1.3" />
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.3" />
    </svg>
  );
}

export default Component;
